
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'ri-time-line',
      title: 'Instalación rápida',
      description: 'Ejecución eficiente que minimiza las molestias en tu hogar u oficina.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Garantía de calidad',
      description: 'Materiales de primera calidad y acabados profesionales garantizados.',
    },
    {
      icon: 'ri-sound-module-line',
      title: 'Mejora acústica',
      description: 'Reducción significativa del ruido entre estancias y del exterior.',
    },
    {
      icon: 'ri-temp-cold-line',
      title: 'Eficiencia térmica',
      description: 'Aislamiento que reduce el consumo energético y mejora el confort.',
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Acabado perfecto',
      description: 'Superficies lisas listas para pintar o decorar según tus gustos.',
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Sin interrupciones',
      description: 'Trabajamos en viviendas ocupadas con máximo respeto y limpieza.',
    },
  ];

  return (
    <section className="py-24 bg-bg-light">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-primary-dark text-5xl md:text-6xl font-serif font-bold mb-6">
            Ventajas de nuestros servicios
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Cuando eliges <Link to="/empresa" className="text-primary hover:underline font-semibold">PLADUREX</Link> para tu proyecto de <Link to="/servicios" className="text-primary hover:underline font-semibold">pladur en Barcelona</Link>, obtienes profesionalidad, rapidez y resultados excepcionales.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-all duration-300"
            >
              <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-primary text-3xl`}></i>
              </div>
              <h3 className="text-primary-dark text-xl font-bold mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-600 text-[15px] leading-relaxed">
                {benefit.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-gray-600 mb-6">
            ¿Tienes dudas sobre nuestros servicios? Consulta nuestras <Link to="/faq" className="text-primary hover:underline font-semibold">preguntas frecuentes</Link> o <Link to="/contacto" className="text-primary hover:underline font-semibold">contacta con nosotros</Link>.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default BenefitsSection;
